module.exports = __webpack_public_path__ + "static/media/slideshow-image_Two.27aabddc.png";